import React from 'react';
import { useFlexLayout, useTable } from 'react-table';

import { ReactTableWrapper } from 'ui-components/components/react-table-wrapper/react-table-wrapper';

import { createCheckboxColumnDefinition } from './columns/checkbox';
import { createNameColumnDefinition } from './columns/name';
import style from './style.module.css';

import type { CarrierPackagesTableProps } from './carrier-packages-table.d';
import type { TableOptions } from 'react-table';

type CarrierPackagesTableOptions = TableOptions<Record<string, unknown>> & {
  onSelectionChange: CarrierPackagesTableProps['onSelectionChange'];
  data: CarrierPackagesTableProps['data'];
};

export const CarrierPackagesTable = ({ data, onSelectionChange }: CarrierPackagesTableProps) => {
  const columns = React.useMemo(
    () => [
      {
        ...createCheckboxColumnDefinition(),
        data,
        onSelectionChange,
      },
      createNameColumnDefinition(),
    ],
    [data, onSelectionChange],
  );

  const { getTableProps, headerGroups, getTableBodyProps, rows, prepareRow } = useTable(
    {
      columns,
      data,
      onSelectionChange,
    } as CarrierPackagesTableOptions,
    useFlexLayout,
  );

  const getBodyRowClassName = () => style['body-row'];

  return (
    <ReactTableWrapper
      className={style['carrier-packages-table']}
      getBodyRowClassName={getBodyRowClassName}
      getTableBodyProps={getTableBodyProps}
      getTableProps={getTableProps}
      headerGroups={headerGroups}
      headerRowClassName={style['header-row']}
      prepareRow={prepareRow}
      rows={rows}
    />
  );
};
